import React, { forwardRef } from "react";

/**
 * Text input with optional leading icon and label.
 * Forwarded ref + native props, so behaviour is identical to a raw <input>.
 */
const Input = forwardRef(function Input(
    { label, icon: Icon, className = "", containerClassName = "", error, hint, ...props },
    ref
) {
    return (
        <div className={containerClassName}>
            {label && (
                <label className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                    {label}
                </label>
            )}
            <div className="relative">
                {Icon && (
                    <Icon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                )}
                <input
                    ref={ref}
                    className={`field-base ${Icon ? "pl-10" : ""} ${
                        error ? "border-danger-400 focus:border-danger-500 focus:ring-danger-500/10" : ""
                    } ${className}`}
                    {...props}
                />
            </div>
            {error ? (
                <p className="mt-1.5 text-xs text-danger-600 dark:text-danger-400">{error}</p>
            ) : hint ? (
                <p className="mt-1.5 text-xs text-slate-500 dark:text-slate-400">{hint}</p>
            ) : null}
        </div>
    );
});

export default Input;
